import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  button: {
    minWidth: 'auto',
    padding: 2,
    background: 'transparent',
    borderRadius: '50%',
  },
  buttonActive: {
    transform: 'rotate(90deg)',
  },
  chevronIcon: {
    fontSize: 18,
    color: '#555',
  },
}));
